export const urls = {
  dashboard: "dashboard/",
  logsCount: "dashboard/logs-count",
  createSite: "site-widget-appearance/site",
  userSites: "site-widget-appearance/sites",
  startCrawling: "crawling/start_full_crawl",
  startRecrawl: "crawling/start_recrawl_full",
  getcrawl: "crawling/crawl_status",
  deleteurl: "crawling/delete_url",
  updateRecrawlurl: "crawling/recrawl_url",
  createChatSession: "chatbot/create_chat_session",
  getAppearanceUrl: (siteId) => `chatbot/site/${siteId}/appearance`,
  newChat: "chatbot/chat",
  emailTranscript: "chatbot/chat_transcript_mail",
  deleteChatSession: "chatbot/delete_chat_session",
  chatFeedback: "chatbot/chat_feedback",
  getChatMessages: (sessionId) => `chatbot/session/${sessionId}/messages`,
  getlogs: "dashboard/complete-logs-data",
  getFeedback: "dashboard/get_like_dislike_data",
  getToDisccussTopics: "dashboard/top-discussed-topics",
  updateTopDiscussTopics: "dashboard/update-top-discussed-topics",
};
